import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from "@components/common/checkbox/main";
import * as RowPage from '@components/common/shroud/row_page';
import UGTDisclaimer from '@components/common/language_menu/ugtDisclaimer';
import { ListDropdown } from '@components/library/dropdown';

import TagsRow from './tags_row';
import BulkManagementLanguageMenuDropdown from '../user_generated_translations/BulkManagementLanguageMenuDropdown';
import {
  getLanguageMapEntryFromSearchString,
  getUgtLocaleSearchString
} from '../user_generated_translations/bulk_ugt_helpers';

import './styles/main.scss';

class TagsManagement extends React.Component {
  state = {
    showAutoGenerated: false,
    visibleTags: this.props.userGeneratedTags,
    queryString: null,
    sortBy: "name",
    pageSize: this.getPageSize(this.props.userGeneratedTags)
  }

  componentDidMount() {
    this.tagsToShow();
  }

  getPageSize(updatedTags) {
    return RowPage.getPageSize(Object.keys(updatedTags).length);
  }

  updateSearch = (event) => {
    this.setState({ queryString: event.target.value });
  }

  toggleAutoGenerated = () => {
    this.setState((prevState) => ({ showAutoGenerated: !prevState.showAutoGenerated }),
      this.tagsToShow);
  }

  handleSorting = (selection) => {
    this.setState({ sortBy: selection.value });
  }

  updateTags = (oldName, newName) => {
    const data = {
      data: {
        manage_tags: {
          management_action: newName ? "update" : "delete",
          brandfolder_key: BF.fx.brandfolder().key,
          old_name: oldName,
          new_name: newName,
          auto_generated: this.state.showAutoGenerated,
          // locale: BFG.locales.staticSiteLocale
        }
      }
    };
    $.ajax({
      type: 'PUT',
      url: `/api/v4/bulk_actions/assets/manage_tags${getUgtLocaleSearchString()}`,
      contentType: 'application/json',
      headers: { Authorization: `Bearer ${BF_Token}` },
      data: JSON.stringify(data),
      context: this,
      success: () => {
        this.updateVisibleTags(oldName, newName);
      }
    });
  }

  updateVisibleTags(oldName, newName) {
    const { visibleTags } = this.state;
    let updatedTags;
    if (newName) {
      updatedTags = Object.assign(visibleTags, { [newName]: visibleTags[oldName] });
    } else {
      updatedTags = Object.assign({}, visibleTags);
    }
    delete updatedTags[oldName];
    const pageSize = this.getPageSize(updatedTags);
    this.setState({ visibleTags: updatedTags, pageSize });
  }

  tagsToShow() {
    if (this.state && this.state.showAutoGenerated) {
      this.setState({
        visibleTags: this.props.autoGeneratedTags,
        pageSize: this.getPageSize(this.props.autoGeneratedTags)
      });
    } else {
      this.setState({
        visibleTags: this.props.userGeneratedTags,
        pageSize: this.getPageSize(this.props.userGeneratedTags)
      });
    }
  }

  queriedNames() {
    const { visibleTags, queryString } = this.state;
    return Object.keys(visibleTags).filter((tagName) => (
      tagName.toLowerCase().includes(queryString.toLowerCase())));
  }

  namesSortedByName() {
    const { visibleTags, queryString } = this.state;
    const namesToSort = queryString ? this.queriedNames() : Object.keys(visibleTags);
    return namesToSort.sort((a, b) => ((a.toLowerCase() < b.toLowerCase()) ? -1 : 1));
  }

  namesSortedByCount() {
    const { visibleTags, queryString } = this.state;
    const namesToSort = queryString ? this.queriedNames() : Object.keys(visibleTags);
    return namesToSort.sort((a, b) => ((visibleTags[a] < visibleTags[b]) ? 1 : -1));
  }

  sortedTags() {
    const { sortBy } = this.state;
    return sortBy === "assetCount" ? this.namesSortedByCount() : this.namesSortedByName();
  }

  renderRows(pageIndex) {
    const { visibleTags } = this.state;
    const tags = RowPage.getPageSlice(pageIndex, this.state.pageSize, this.sortedTags());
    return tags.map((tagName) => (
      <div key={tagName} className="tag-row">
        <TagsRow
          autoGenerated={this.state.showAutoGenerated}
          count={visibleTags[tagName]}
          name={tagName}
          updateTags={this.updateTags}
        />
      </div>
    ));
  }

  renderPages() {
    const numPages = RowPage.getNumPages(this.state.pageSize, this.sortedTags().length);
    const renderedPages = [];
    for (let pageIndex = 0; pageIndex < numPages; pageIndex += 1) {
      renderedPages.push(
        <RowPage.RowPage
          key={`tag-row-page-${pageIndex}`}
          isInitialPage={pageIndex === 0}
          pageSize={this.state.pageSize}
          renderRows={() => this.renderRows(pageIndex)}
          rowHeight={71}
        />
      );
    }
    return renderedPages;
  }

  renderSortingOptions() {
    const { userGeneratedTags, autoGeneratedTags } = this.props;
    const { showAutoGenerated } = this.state;
    const tagCount = Object.keys((showAutoGenerated ? autoGeneratedTags : userGeneratedTags)).length;
    return (
      <div className="sorting-options">
        <input
          className="bf-input searchbar"
          id="tag-search"
          onChange={this.updateSearch}
          placeholder={`${bfTranslate('Search')} ${tagCount} ${bfTranslate('tags')}`}
          type="text"
        />
        <div className="sorting-options-container-right">
          <BulkManagementLanguageMenuDropdown />
          <div className="sort-options">
            <div><p>{bfTranslate('Sort by')}:</p></div>
            <ListDropdown
                className="select-tag-sorting"
                onChange={this.handleSorting}
                options={[
                  { value: 'name', label: bfTranslate('Name') }, 
                  { value: 'assetCount', label: bfTranslate('Asset Count') }]}
                searchable={false}
                value={this.state.sortBy}
                virtualizeOptions={false}
              />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { autoGeneratedTags } = this.props;
    const labelCopy = <h5>{bfTranslate('Show auto-generated tags')}</h5>;
    return (
      <div className="manage-tags">
        <UGTDisclaimer getSelectedLanguage={getLanguageMapEntryFromSearchString} />
        <h2>{bfTranslate('Tags for')} {BF.fx.brandfolder().name}</h2>
        <hr />
        {this.renderSortingOptions()}
        <div className="filter-by-auto-generated-tags">
          { Object.keys(autoGeneratedTags).length
            ? (
              <Checkbox
                checked={this.state.showAutoGenerated}
                labelHtml={labelCopy}
                size="sm"
                toggle={() => this.toggleAutoGenerated()}
              />
            ) : null }
        </div>
        <div className="headers">
          <div className="headers-container">
            <h3 className="quarter-width">{bfTranslate('Tags')}</h3>
            <h3 className="fifteen-width"># {bfTranslate('Assets')}</h3>
          </div>
        </div>
        <div className="tags-list">
          {this.renderPages()}
        </div>
      </div>
    );
  }
}

TagsManagement.propTypes = {
  userGeneratedTags: PropTypes.objectOf(PropTypes.number).isRequired,
  autoGeneratedTags: PropTypes.objectOf(PropTypes.number).isRequired
};

export default TagsManagement;
